/* FOYENA - hero d'accueil : le vrai ciel, calcule en direct, qui tourne lentement. */
(function () {
  var D2R = Math.PI / 180;
  var MONTHS = ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"];
    // styles : inline dans la section (pas de flash au chargement)
  if (!document.querySelector('link[data-fy-fonts]')) {
    var l = document.createElement("link"); l.rel = "stylesheet"; l.setAttribute("data-fy-fonts", "1");
    l.href = "https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,300;14..32,900&family=Lora:ital,wght@0,400;1,400&family=Poppins:wght@300;500&display=swap";
    document.head.appendChild(l);
  }

  function lst(ms, lon) {
    var jd = ms / 86400000 + 2440587.5, d = jd - 2451545, t = d / 36525;
    var g = 280.46061837 + 360.98564736629 * d + 0.000387933 * t * t - t * t * t / 38710000;
    return (((g + lon) % 360) + 360) % 360 * D2R;
  }
  function tzOff(ms, tz) {
    try {
      var p = new Intl.DateTimeFormat("en-US", { timeZone: tz, hourCycle: "h23", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" }).formatToParts(new Date(ms));
      var o = {}; p.forEach(function (x) { o[x.type] = +x.value; });
      return (Date.UTC(o.year, o.month - 1, o.day, o.hour % 24, o.minute, o.second) - ms) / 60000;
    } catch (e) { return 60; }
  }
  function toUtc(y, m, d, hh, mm, tz) { var g = Date.UTC(y, m - 1, d, hh, mm); return g - tzOff(g - tzOff(g, tz) * 6e4, tz) * 6e4; }

  var stars = null, lines = null;
  function prep() {
    if (stars || !window.FY_SKY) return;
    var s = window.FY_SKY.s, n = s.length / 3; stars = [];
    for (var i = 0; i < n; i++) { var de = s[3 * i + 1] * D2R; stars.push([s[3 * i] * D2R, Math.sin(de), Math.cos(de), s[3 * i + 2]]); }
    lines = window.FY_SKY.l;
  }
  function proj(ra, sd, cd, L, sl, cl) {
    var h = L - ra, ch = Math.cos(h), sa = sd * sl + cd * cl * ch;
    var alt = Math.asin(Math.max(-1, Math.min(1, sa)));
    var az = Math.atan2(-cd * Math.sin(h), sd * cl - cd * sl * ch);
    var r = Math.tan((Math.PI / 2 - alt) / 2);
    return [-r * Math.sin(az), r * Math.cos(az), alt];
  }

  var drag = { on: false, x: 0, off: 0, v: 0, last: 0, used: false };
  var MS_PER_PX = 60000, base21 = 0; // 1 px glisse = 1 minute de ciel ; on reste entre 18 h et 7 h
  function clampOff() {
    var lo = base21 - 3 * 3600000, hi = base21 + 10 * 3600000, t = view.utc + drag.off;
    if (t < lo) { drag.off = lo - view.utc; drag.v = 0; } else if (t > hi) { drag.off = hi - view.utc; drag.v = 0; }
  }
  var cv, ctx, cap, view = { utc: 0, lat: 48.8566, lon: 2.3522 }, target = null, placeName = "Paris", tz = "Europe/Paris", chosen = null;
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function draw() {
    prep(); if (!stars) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), w = Math.round(cv.clientWidth * dpr);
    if (!w) return;
    if (cv.width !== w) { cv.width = w; cv.height = w; }
    var W = w, R = W * 0.46, cx = W / 2, cy = W / 2;
    ctx.clearRect(0, 0, W, W);
    var L = lst(view.utc + drag.off, view.lon), la = view.lat * D2R, sl = Math.sin(la), cl = Math.cos(la);
    var X = function (x) { return cx + x * R; }, Y = function (y) { return cy - y * R; };
    ctx.save(); ctx.beginPath(); ctx.arc(cx, cy, R, 0, 2 * Math.PI); ctx.clip();
    var g = ctx.createRadialGradient(cx, cy, 0, cx, cy, R); g.addColorStop(0, "#13203A"); g.addColorStop(1, "#0B1426");
    ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);
    ctx.strokeStyle = "#2A3A5C"; ctx.lineWidth = W / 1400;
    [30, 60].forEach(function (a) { ctx.beginPath(); ctx.arc(cx, cy, Math.tan((90 - a) * D2R / 2) * R, 0, 2 * Math.PI); ctx.stroke(); });
    ctx.strokeStyle = "rgba(201,179,126,.55)"; ctx.lineWidth = W / 900; ctx.lineCap = "round"; ctx.beginPath();
    lines.forEach(function (ln) {
      var pv = null;
      for (var i = 0; i < ln.length; i += 2) {
        var de = ln[i + 1] * D2R, p = proj(ln[i] * D2R, Math.sin(de), Math.cos(de), L, sl, cl);
        if (pv && pv[2] > -0.02 && p[2] > -0.02) { ctx.moveTo(X(pv[0]), Y(pv[1])); ctx.lineTo(X(p[0]), Y(p[1])); }
        pv = p;
      }
    });
    ctx.stroke();
    ctx.fillStyle = "#FFF8E7";
    var k = W / 620;
    for (var i = 0; i < stars.length; i++) {
      var s = stars[i], p = proj(s[0], s[1], s[2], L, sl, cl);
      if (p[2] <= 0) continue;
      var r = Math.max(0.35 * k, Math.sqrt(Math.min(60, Math.max(0.15, Math.pow(6.3 - s[3], 2.1) * 0.55))) * 0.62 * k);
      if (s[3] < 1.8) { ctx.globalAlpha = 0.12; ctx.beginPath(); ctx.arc(X(p[0]), Y(p[1]), r * 2.6, 0, 6.2832); ctx.fill(); ctx.globalAlpha = 1; }
      ctx.beginPath(); ctx.arc(X(p[0]), Y(p[1]), r, 0, 6.2832); ctx.fill();
    }
    ctx.restore();
    ctx.strokeStyle = "#C9B37E"; ctx.lineWidth = W / 380; ctx.beginPath(); ctx.arc(cx, cy, R, 0, 6.2832); ctx.stroke();
    ctx.lineWidth = W / 1200; ctx.beginPath(); ctx.arc(cx, cy, R * 1.03, 0, 6.2832); ctx.stroke();
    ctx.fillStyle = "rgba(243,233,210,.75)"; ctx.font = "500 " + Math.round(W / 46) + "px Poppins, sans-serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    [["N", 0, 1.075], ["S", 0, -1.075], ["E", -1.075, 0], ["O", 1.075, 0]].forEach(function (c) { ctx.fillText(c[0], X(c[1] * 0.985), Y(c[2] * 0.985)); });
  }

  function hourTxt() {
    try {
      var p = new Intl.DateTimeFormat("fr-FR", { timeZone: tz, hour: "2-digit", minute: "2-digit" }).format(new Date(view.utc + drag.off));
      return " · vers " + p.replace(":", " h ");
    } catch (e) { return ""; }
  }
  function caption() {
    if (!cap) return;
    if (drag.used) {
      cap.textContent = "Le ciel au-dessus de " + placeName + (chosen ? ", la nuit du " + chosen.d + " " + MONTHS[chosen.m - 1] + " " + chosen.y : ", cette nuit") + hourTxt();
      return;
    }
    if (!chosen) { cap.textContent = "Le ciel au-dessus de " + placeName + ", cette nuit"; return; }
    cap.textContent = "Le ciel au-dessus de " + placeName + ", la nuit du " + chosen.d + " " + MONTHS[chosen.m - 1] + " " + chosen.y;
  }

  var last = 0, anchor = 0, t0 = null;
  function loop(t) {
    var dt = last ? Math.min(t - last, 100) : 16; last = t;
    if (target) {
      var a = Math.min(1, (t - target.t0) / target.dur), e = a < 0.5 ? 4 * a * a * a : 1 - Math.pow(-2 * a + 2, 3) / 2;
      view.utc = target.from.utc + (target.to.utc - target.from.utc) * e;
      view.lat = target.from.lat + (target.to.lat - target.from.lat) * e;
      view.lon = target.from.lon + (target.to.lon - target.from.lon) * e;
      if (a >= 1) target = null;
      if (!target) { anchor = view.utc; t0 = t; }
    } else if (drag.on) {
      // la derive est en pause : on garde l'ancre
      t0 = t - drag.t0shift;
    } else if (!reduce) {
      // le ciel parcourt doucement la nuit (21 h -> 5 h) puis revient, en 160 s
      if (t0 === null) { anchor = view.utc; t0 = t; }
      view.utc = anchor + 8 * 3600000 * (1 - Math.cos(2 * Math.PI * (t - t0) / 160000)) / 2;
    }
    if (!drag.on && Math.abs(drag.v) > 0.01) { drag.off += drag.v * dt * MS_PER_PX; drag.v *= Math.pow(0.92, dt / 16); clampOff(); }
    if (drag.used && (drag.on || Math.abs(drag.v) > 0.01)) caption();
    draw();
    requestAnimationFrame(loop);
  }

  function goTo(y, m, d, lat, lon, zone) {
    var to = { utc: toUtc(y, m, d, 21, 0, zone), lat: lat, lon: lon };
    base21 = to.utc;
    // on garde l'angle sideral proche pour une rotation lisible (pas des milliers de tours)
    var sid = 86164090.5, diff = to.utc - view.utc, turns = Math.round(diff / sid);
    var fromUtc = view.utc + turns * sid;
    view.utc += drag.off; drag.off = 0; drag.v = 0;
    if (reduce) { view = to; target = null; draw(); return; }
    t0 = null;
    target = { from: { utc: fromUtc, lat: view.lat, lon: view.lon }, to: to, t0: performance.now(), dur: 1600 };
    view.utc = fromUtc;
  }

  var geoT = null, geo = null;
  function geocode(q, cb) {
    fetch("https://photon.komoot.io/api/?limit=1&lang=fr&osm_tag=place&q=" + encodeURIComponent(q)).then(function (r) { return r.json(); }).then(function (j) {
      var f = j.features && j.features[0]; if (!f) return;
      var p = f.properties, c = f.geometry.coordinates, cc = (p.countrycode || "").toUpperCase();
      var zone = cc === "FR" || cc === "MC" ? "Europe/Paris" : cc === "BE" ? "Europe/Brussels" : cc === "CH" ? "Europe/Zurich" : cc === "CA" ? "America/Toronto" : null;
      if (!zone) { var h = Math.round(c[0] / 15); zone = h === 0 ? "Etc/GMT" : "Etc/GMT" + (h > 0 ? "-" : "+") + Math.abs(h); }
      cb({ name: p.name, label: p.name + (p.country ? ", " + p.country : ""), lat: c[1], lon: c[0], tz: zone });
    }).catch(function () {});
  }

  function boot() {
    var root = document.querySelector(".fyh"); if (!root) return;
    cv = root.querySelector("canvas"); ctx = cv.getContext("2d"); cap = root.querySelector("figcaption");
    var now = new Date(), y = now.getFullYear(), m = now.getMonth() + 1, d = now.getDate();
    view.utc = toUtc(y, m, d, 21, 0, tz); base21 = view.utc;
    caption();
    var form = root.querySelector(".fyh-try"), di = form.querySelector('input[type=date]'), ci = form.querySelector('input[type=text]');
    function apply() {
      var md = /^(\d{4})-(\d{2})-(\d{2})$/.exec(di.value);
      var place = geo || { lat: 48.8566, lon: 2.3522, tz: "Europe/Paris", name: "Paris", label: "Paris, France" };
      placeName = place.name;
      if (md) { chosen = { y: +md[1], m: +md[2], d: +md[3] }; goTo(chosen.y, chosen.m, chosen.d, place.lat, place.lon, place.tz); }
      else { var n = new Date(); goTo(n.getFullYear(), n.getMonth() + 1, n.getDate(), place.lat, place.lon, place.tz); }
      caption();
    }
    di.addEventListener("change", apply);
    ci.addEventListener("input", function () {
      clearTimeout(geoT); var q = ci.value.trim();
      if (q.length < 2) { geo = null; return; }
      geoT = setTimeout(function () { geocode(q, function (g) { if (ci.value.trim() !== q) return; geo = g; apply(); }); }, 450);
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var u = new URLSearchParams();
      if (di.value) u.set("date", di.value);
      if (geo) { u.set("lieu", geo.label); u.set("lat", geo.lat.toFixed(4)); u.set("lon", geo.lon.toFixed(4)); u.set("tz", geo.tz); }
      else if (ci.value.trim()) u.set("lieu", ci.value.trim());
      location.href = form.getAttribute("action") + (u.toString() ? "?" + u.toString() : "");
    });
    // glisser pour parcourir la nuit (horizontal ; le defilement vertical de la page reste libre)
    var st = document.createElement("style");
    st.textContent = ".fyh-sky canvas{cursor:grab;touch-action:pan-y;-webkit-user-select:none;user-select:none}.fyh-sky canvas.drag{cursor:grabbing}" +
      ".fyh-hint{margin:-6px 0 0;font-size:.78rem;letter-spacing:.02em;color:rgba(243,233,210,.55);display:flex;align-items:center;gap:8px;transition:opacity .6s}.fyh-hint svg{opacity:.8}";
    document.head.appendChild(st);
    var hint = document.createElement("p"); hint.className = "fyh-hint";
    hint.innerHTML = '<svg width="26" height="10" viewBox="0 0 26 10" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" aria-hidden="true"><path d="M5 1 1 5l4 4M21 1l4 4-4 4M1 5h24"/></svg>Faites glisser le ciel pour parcourir la nuit';
    cv.parentNode.appendChild(hint);
    cv.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      drag.on = true; drag.x = e.clientX; drag.last = performance.now(); drag.v = 0; drag.used = true;
      drag.t0shift = t0 === null ? 0 : performance.now() - t0;
      cv.classList.add("drag"); try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      hint.style.opacity = "0";
    });
    cv.addEventListener("pointermove", function (e) {
      if (!drag.on) return;
      var now = performance.now(), dx = e.clientX - drag.x, dtm = Math.max(1, now - drag.last);
      // les etoiles vont de l'est (gauche) vers l'ouest (droite) : glisser vers la droite = avancer dans la nuit
      drag.off += dx * MS_PER_PX; drag.v = dx / dtm; clampOff(); drag.x = e.clientX; drag.last = now;
    });
    var end = function () { if (!drag.on) return; drag.on = false; cv.classList.remove("drag"); if (performance.now() - drag.last > 80) drag.v = 0; caption(); };
    cv.addEventListener("pointerup", end); cv.addEventListener("pointercancel", end); cv.addEventListener("lostpointercapture", end);
    cv.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") { e.preventDefault(); drag.used = true; drag.off += (e.key === "ArrowRight" ? 1 : -1) * 15 * 60000; clampOff(); caption(); }
    });
    cv.tabIndex = 0; cv.setAttribute("aria-label", "Carte du ciel calculée en direct. Flèches gauche et droite pour avancer ou reculer dans la nuit.");
    var started = false, start = function () { if (started) return; started = true; requestAnimationFrame(loop); };
    if (window.FY_SKY) start(); else { var w = setInterval(function () { if (window.FY_SKY) { clearInterval(w); start(); } }, 200); }
    if (document.fonts) document.fonts.load('500 20px "Poppins"').then(draw).catch(function () {});
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
